import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/app/global-error.tsx");
